import general from './GeneralReducers';
import user from './UserReducers';

// eslint-disable-next-line import/no-anonymous-default-export
export default({ general, user});
